export const CREATE_INMAILS = "CREATE@CREATE_INMAILS";
export const CREATE_INMAILS_INIT = "CREATE@CREATE_INMAILS_INIT";
export const CREATE_INMAILS_SUCCESS = "CREATE@CREATE_INMAILS_SUCCESS";
export const CREATE_INMAILS_FAILED = "CREATE@CREATE_INMAILS_FAILED";

export const GET_ALLOCATORS = "GET@ALLOCATORS_INMAIL";
export const GET_ALLOCATORS_INIT = "GET@ALLOCATORS_INMAIL_INIT";
export const GET_ALLOCATORS_SUCCESS = "GET@ALLOCATORS_INMAIL_SUCCESS";
export const GET_ALLOCATORS_FAILED = "GET@ALLOCATORS_INMAIL_FAILED";

export const ALLOCATORS_COUNT = "GET@ALLOCATORS_COUNT";
export const ALLOCATORS_COUNT_INIT = "GET@ALLOCATORS_COUNT_INIT";
export const ALLOCATORS_COUNT_SUCCESS = "GET@ALLOCATORS_COUNT_SUCCESS";
export const ALLOCATORS_COUNT_FAILED = "GET@ALLOCATORS_COUNT_FAILED";
